<script lang="ts">
  import {
    DEFAULT_FLOATING_ACTION_BUTTON_POSITION,
    getPositionStyle,
  } from "website_script/lib/widgetPosition"
  import type { Settings } from "website_script/types/settings"
  import FABButton from "./FABButton.svelte"
  import { getContext, onMount } from "svelte"
  import { getTopPrompt } from "website_script/lib/widgetPrompts"
  import WidgetPopover from "../components/WidgetPopover.svelte"
  import IntegrationTypes from "website_script/constants/IntegrationTypes"
  import { Environment } from "website_script/types/environment"

  let popover: WidgetPopover
  let isPromptShown: boolean = false

  const { enableFloatingActionButton, floatingActionButtonConfig } =
    getContext<Settings>("settings")
  const { trackFunction } = getContext<Environment>("environment")

  const widgetPosition =
    floatingActionButtonConfig.position ||
    DEFAULT_FLOATING_ACTION_BUTTON_POSITION
  const positionStyle = getPositionStyle(widgetPosition)

  const { buttonConfig, promptConfig } = getTopPrompt(
    floatingActionButtonConfig.prompts || [],
    floatingActionButtonConfig.buttons
  )

  onMount(() => {
    const timeout = setTimeout(() => {
      isPromptShown = true
    }, (floatingActionButtonConfig.promptDelay ?? 0) * 1000)

    if (
      enableFloatingActionButton &&
      floatingActionButtonConfig.buttons.length > 0
    ) {
      trackFunction({
        entity: "floating-action-button",
        action: "displayed",
        flow: floatingActionButtonConfig.buttons.map((b) => b.flow_type),
        type: "displayed_cta",
      })
    }

    return () => {
      clearTimeout(timeout)
    }
  })
</script>

{#if enableFloatingActionButton}
  <div class="au-floating-action-button" style={positionStyle}>
    {#each floatingActionButtonConfig.buttons as buttonConfig}
      {#if popover && promptConfig && promptConfig.lead_flow_id === buttonConfig.lead_flow_id}
        <FABButton
          {buttonConfig}
          use={[
            popover.getPopoverInstance().floatingRef,
            popover.getPopoverInstance().triggerRef,
          ]}
        />
      {:else}
        <FABButton {buttonConfig} />
      {/if}
    {/each}
  </div>

  {#if buttonConfig && promptConfig && isPromptShown}
    <WidgetPopover
      bind:this={popover}
      integrationType={IntegrationTypes.FLOATING_ACTION_BUTTON}
      {buttonConfig}
      {promptConfig}
      {widgetPosition}
    />
  {/if}
{/if}

<style>
  .au-floating-action-button {
    z-index: var(--au-z-index-widget);
    position: fixed;
    display: flex;
    flex-direction: row;
    border-radius: var(--au-tappable-size);
    background-color: var(--au-button-primary-background-color);
    box-shadow: var(--au-box-shadow-strong);
    border: 2px solid var(--au-background-default);
    font-size: var(--au-text-body-small-font-size);
    line-height: var(--au-text-body-small-line-height);
  }
</style>
